import {Component} from '@angular/core';
import {Events, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

@Component({
    selector: 'page-customer-name-modal',
    templateUrl: 'customer-name-modal.html',
})
export class CustomerNameModalPage {

    errors: {};
    loading: boolean;
    name: any;
    phone: any;
    buttonText: any;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams, public events: Events, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        this.name = '';
        this.buttonText = 'Register Name';
    }

    registerGuestUser() {
        this.loading = true;

        return new Promise((resolve, reject) => {
            this.http.post(`/customers/registerGuest`, {
                terms: true,
                name: this.name,
                phone: this.phone
            }).subscribe(user => {
                this.errors = {};
                this.loading = false;
                this.viewCtrl.dismiss(user);
                return resolve(user)
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
                return reject(this.errors)
            })
        });
    }

    closeModal() {
        this.viewCtrl.dismiss().then(() => {
          this.events.publish('staff:enableRefresh');
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/customer-name-modal/customer-name-modal.ts